(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vibezone-header"] && !Shopify.designMode) return;
  try {
    
/* VIBEZONE — NIGHT | globalny JS (bez zależności) */
(function () {
  'use strict';
  if (window.VZ && window.VZ.__ready) return;
  var VZ = window.VZ = window.VZ || {};
  VZ.__ready = true;
  var doc = document, root = doc.documentElement;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  root.classList.add('vz-js');

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  VZ.money = function (c) { return (c / 100).toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' }); };
  VZ.img = function (u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (u.indexOf('cdn.shopify.com') === -1 && u.indexOf('/cdn/shop/') === -1) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };
  var I = {
    minus: '<svg class="vz-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg class="vz-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg class="vz-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    bag: '<svg class="vz-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1.2 11.2a1 1 0 0 1-1 .8H7.2a1 1 0 0 1-1-.8L5 8z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>',
    heart: '<svg class="vz-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>',
    x: '<svg class="vz-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };

  /* ---------- API (w podglądzie nadpisywane przez VZ.api) ---------- */
  var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var jpost = function (url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  };
  VZ.api = VZ.api || {
    get: function () { return fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
    add: function (items) { return jpost(R + 'cart/add.js', { items: items }); },
    change: function (key, q) { return jpost(R + 'cart/change.js', { id: key, quantity: q }); },
    product: function (handle) {
      return fetch(R + 'products/' + encodeURIComponent(handle) + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (p) {
        return {
          title: p.title, url: p.url || (R + 'products/' + p.handle), type: p.type,
          images: (p.images || []).map(function (u) { return u.indexOf('//') === 0 ? 'https:' + u : u; }),
          options: (p.options || []).map(function (o) { return typeof o === 'string' ? { name: o, values: [] } : o; }),
          variants: p.variants.map(function (v) { return { id: v.id, title: v.title, options: v.options, price: v.price, compare_at_price: v.compare_at_price || 0, available: v.available }; })
        };
      });
    }
  };

  /* ---------- Toast ---------- */
  var toastEl, toastT;
  VZ.toast = function (msg) {
    if (!toastEl) { toastEl = doc.createElement('div'); toastEl.className = 'vz vz-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); doc.body.appendChild(toastEl); }
    toastEl.innerHTML = I.check + '<span>' + esc(msg) + '</span>';
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  };

  /* ---------- Reveal ---------- */
  function initReveal(scope) {
    $$('[data-vz-stagger]', scope).forEach(function (p) {
      var step = parseInt(p.getAttribute('data-vz-stagger'), 10) || 80;
      $$('[data-vz-reveal]', p).forEach(function (el, i) { el.style.setProperty('--vz-d', Math.min(i * step, 600) + 'ms'); });
    });
    var els = $$('[data-vz-reveal]:not(.is-in), .vz-stage:not(.is-in), .vz-bar:not(.is-in)', scope);
    if (RM.matches || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    els.forEach(function (e) { io.observe(e); });
  }
  VZ.reveal = initReveal;

  /* ---------- Header ---------- */
  function initHeader() {
    var h = $('.vz-header'); if (!h) return;
    var tick = false;
    function upd() { h.classList.toggle('is-scrolled', window.pageYOffset > 8); tick = false; }
    window.addEventListener('scroll', function () { if (!tick) { requestAnimationFrame(upd); tick = true; } }, { passive: true });
    upd();
  }

  /* ---------- Panele (szuflady, wyszukiwarka, modal) ---------- */
  var openEl = null, lastFocus = null;
  function focusables(el) { return $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', el).filter(function (x) { return x.offsetParent !== null; }); }
  VZ.open = function (name) {
    var el = $('[data-vz-panel="' + name + '"]'); if (!el) return;
    if (openEl && openEl !== el) VZ.close(true);
    lastFocus = doc.activeElement; openEl = el;
    el.classList.add('is-open'); el.removeAttribute('aria-hidden');
    var sc = $('.vz-scrim'); if (sc) sc.classList.add('is-open');
    root.style.overflow = 'hidden';
    $$('[aria-controls="vz-' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var f = $('[data-vz-autofocus]', el) || focusables(el)[0]; if (f) f.focus({ preventScroll: true }); }, 80);
    if (name === 'cart') VZ.renderCart();
    if (name === 'wish') VZ.renderWish();
  };
  VZ.close = function (silent) {
    if (!openEl) return;
    var name = openEl.getAttribute('data-vz-panel');
    openEl.classList.remove('is-open'); openEl.setAttribute('aria-hidden', 'true');
    var sc = $('.vz-scrim'); if (sc) sc.classList.remove('is-open');
    root.style.overflow = '';
    $$('[aria-controls="vz-' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openEl = null;
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  doc.addEventListener('click', function (e) {
    var o = e.target.closest('[data-vz-open]');
    if (o) { e.preventDefault(); VZ.open(o.getAttribute('data-vz-open')); return; }
    if (e.target.closest('[data-vz-close]') || e.target.classList.contains('vz-scrim') || e.target.classList.contains('vz-modal')) { e.preventDefault(); VZ.close(); }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') VZ.close();
    if (e.key === '/' && !openEl && !/INPUT|TEXTAREA|SELECT/.test(doc.activeElement.tagName)) { e.preventDefault(); VZ.open('search'); }
    if (openEl && e.key === 'Tab') {
      var f = focusables(openEl); if (!f.length) return;
      if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------- Koszyk ---------- */
  VZ.setCount = function (n, bump) {
    $$('[data-vz-cart-count]').forEach(function (c) {
      c.textContent = n; c.setAttribute('data-count', n);
      if (bump) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
    });
  };
  VZ.renderCart = function (cart) {
    var body = $('[data-vz-cart-body]'); if (!body) return Promise.resolve();
    return (cart ? Promise.resolve(cart) : VZ.api.get()).then(function (c) {
      VZ.setCount(c.item_count);
      var d = $('[data-vz-panel="cart"]'), th = parseInt(d.getAttribute('data-threshold'), 10) || 0, foot = $('[data-vz-cart-foot]');
      var t = $('[data-vz-cart-title-count]'); if (t) t.textContent = c.item_count ? '(' + c.item_count + ')' : '';
      if (!c.item_count) {
        body.innerHTML = '<div class="vz-empty"><div class="vz-empty__ico">' + I.bag + '</div><p>Twój koszyk jest pusty</p><span>Sprawdź, co jest teraz na topie.</span><a class="vz-btn vz-btn--sm" href="' + esc(d.getAttribute('data-shop-url') || '/collections/all') + '"><span class="vz-btn__lbl">Przeglądaj produkty</span></a></div>';
        if (foot) foot.hidden = true; return;
      }
      if (foot) foot.hidden = false;
      var ship = '';
      if (th > 0) {
        var left = th - c.total_price;
        ship = '<div class="vz-ship"><span>' + (left > 0 ? 'Brakuje <strong>' + VZ.money(left) + '</strong> do darmowej dostawy' : '<strong>Masz darmową dostawę!</strong>') + '</span><div class="vz-ship__bar"><i style="--p:0"></i></div></div>';
      }
      body.innerHTML = ship + c.items.map(function (it) {
        var v = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : '';
        return '<div class="vz-ci" data-key="' + esc(it.key) + '"><a class="vz-ci__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(VZ.img(it.image, 180)) + '" alt="" width="76" height="76" loading="lazy">' : '') + '</a>' +
          '<div><p class="vz-ci__t"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p><p class="vz-ci__v">' + v + '</p>' +
          '<div class="vz-qty" role="group" aria-label="Ilość"><button type="button" data-q="-1" aria-label="Zmniejsz ilość">' + I.minus + '</button><output aria-live="polite">' + it.quantity + '</output><button type="button" data-q="1" aria-label="Zwiększ ilość">' + I.plus + '</button></div></div>' +
          '<div style="display:grid;justify-items:end;align-content:space-between"><span class="vz-ci__price">' + VZ.money(it.final_line_price) + '</span><button type="button" class="vz-ci__rm" data-rm>Usuń</button></div></div>';
      }).join('');
      $$('[data-vz-cart-total]').forEach(function (x) { x.textContent = VZ.money(c.total_price); });
      var bar = $('.vz-ship__bar i', body);
      if (bar) requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.setProperty('--p', Math.min(1, c.total_price / th)); }); });
    }).catch(function () { body.innerHTML = '<div class="vz-alert vz-alert--err">Nie udało się wczytać koszyka. Odśwież stronę.</div>'; });
  };
  doc.addEventListener('click', function (e) {
    var row = e.target.closest('.vz-ci'); if (!row) return;
    var q = e.target.closest('[data-q]'), rm = e.target.closest('[data-rm]'); if (!q && !rm) return;
    var cur = parseInt($('output', row).textContent, 10);
    var next = rm ? 0 : Math.max(0, cur + parseInt(q.getAttribute('data-q'), 10));
    if (!next) row.classList.add('is-removing');
    row.style.pointerEvents = 'none';
    VZ.api.change(row.getAttribute('data-key'), next).then(function (c) { setTimeout(function () { VZ.renderCart(c); }, next ? 0 : 280); })
      .catch(function (err) { row.style.pointerEvents = ''; row.classList.remove('is-removing'); VZ.toast((err && err.description) || 'Nie można zmienić ilości'); });
  });
  VZ.addToCart = function (items, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    return VZ.api.add(items).then(function () { return VZ.api.get(); }).then(function (c) {
      VZ.setCount(c.item_count, true);
      if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); btn.disabled = false; }, 1400); }
      var d = $('[data-vz-panel="cart"]');
      if (d && d.getAttribute('data-open-on-add') !== 'false') VZ.open('cart'); else VZ.toast('Dodano do koszyka');
      return c;
    }).catch(function (err) {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      VZ.toast((err && (err.description || err.message)) || 'Nie udało się dodać produktu');
    });
  };
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vz-quick]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var id = b.getAttribute('data-variant-id');
    if (!id) { var h = b.getAttribute('data-handle'); if (h) VZ.quickView(h); else location.href = b.getAttribute('data-href'); return; }
    VZ.addToCart([{ id: +id, quantity: 1 }], b);
  });

  /* ---------- Ulubione (localStorage) ---------- */
  var WK = 'vz_wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WK)) || []; } catch (e) { return VZ._wishMem || []; } }
  function wishSet(a) { VZ._wishMem = a; try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} }
  function wishSync() {
    var list = wishGet(), hs = list.map(function (x) { return x.handle; });
    $$('[data-vz-wish]').forEach(function (b) { var on = hs.indexOf(b.getAttribute('data-handle')) > -1; b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', (on ? 'Usuń z ulubionych: ' : 'Dodaj do ulubionych: ') + (b.getAttribute('data-title') || '')); });
    $$('[data-vz-wish-count]').forEach(function (c) { c.textContent = list.length; c.setAttribute('data-count', list.length); });
  }
  VZ.wishSync = wishSync;
  VZ.renderWish = function () {
    var body = $('[data-vz-wish-body]'); if (!body) return;
    var list = wishGet();
    body.innerHTML = list.length ? list.map(function (x) {
      return '<div class="vz-wi"><a href="' + esc(x.url) + '"><img src="' + esc(VZ.img(x.img, 180)) + '" alt="" loading="lazy"></a><div><a href="' + esc(x.url) + '"><b>' + esc(x.title) + '</b></a><span class="vz-mut" style="font-size:13px">' + (x.price ? VZ.money(+x.price) : '') + '</span></div><button type="button" class="vz-iconbtn" data-vz-wish-rm="' + esc(x.handle) + '" aria-label="Usuń z ulubionych">' + I.x + '</button></div>';
    }).join('') : '<div class="vz-empty"><div class="vz-empty__ico">' + I.heart + '</div><p>Brak ulubionych</p><span>Kliknij serce na produkcie, żeby go tu zapisać.</span></div>';
  };
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vz-wish]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var h = b.getAttribute('data-handle'), list = wishGet(), i = list.findIndex(function (x) { return x.handle === h; });
      if (i > -1) { list.splice(i, 1); VZ.toast('Usunięto z ulubionych'); }
      else { list.unshift({ handle: h, title: b.getAttribute('data-title'), price: b.getAttribute('data-price'), img: b.getAttribute('data-img'), url: b.getAttribute('data-url') }); VZ.toast('Dodano do ulubionych'); }
      wishSet(list); wishSync(); return;
    }
    var r = e.target.closest('[data-vz-wish-rm]');
    if (r) { wishSet(wishGet().filter(function (x) { return x.handle !== r.getAttribute('data-vz-wish-rm'); })); wishSync(); VZ.renderWish(); }
  });

  /* ---------- Quick View ---------- */
  VZ.quickView = function (handle) {
    var m = $('[data-vz-panel="qv"]'), box = m && $('[data-vz-qv-body]', m); if (!box) return;
    box.innerHTML = '<div style="padding:80px;display:grid;place-items:center"><span class="vz-spin" style="display:block;width:28px;height:28px"></span></div>';
    VZ.open('qv');
    VZ.api.product(handle).then(function (p) {
      var multi = p.variants.length > 1;
      var v0 = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      box.innerHTML = '<div class="vz-qv"><div class="vz-qv__media"><img data-qv-img src="' + esc(VZ.img(p.images[0], 900)) + '" alt="' + esc(p.title) + '"></div>' +
        '<div class="vz-qv__body"><span class="vz-kicker"><i></i>Szybki podgląd</span><h2 class="vz-h3" id="vz-qv-title" style="font-size:24px">' + esc(p.title) + '</h2>' +
        '<div class="vz-pprice" data-qv-price></div>' +
        (p.images.length > 1 ? '<div class="vz-qv__thumbs">' + p.images.slice(0, 5).map(function (u, i) { return '<button type="button" data-qv-thumb="' + esc(u) + '" aria-current="' + (i ? 'false' : 'true') + '" aria-label="Zdjęcie ' + (i + 1) + '"><img src="' + esc(VZ.img(u, 140)) + '" alt=""></button>'; }).join('') + '</div>' : '') +
        (multi ? '<fieldset class="vz-opt"><legend>' + esc((p.options[0] && p.options[0].name) || 'Wariant') + '</legend><div class="vz-swatches">' + p.variants.map(function (v, i) { return '<input type="radio" id="qv-v' + i + '" name="qv-v" value="' + v.id + '"' + (v === v0 ? ' checked' : '') + (v.available ? '' : ' class="is-na"') + '><label for="qv-v' + i + '">' + esc(v.title) + '</label>'; }).join('') + '</div></fieldset>' : '') +
        '<div class="vz-buy"><div class="vz-qty vz-qty--lg"><button type="button" data-qv-step="-1" aria-label="Zmniejsz ilość">' + I.minus + '</button><input type="number" value="1" min="1" aria-label="Ilość" data-qv-qty><button type="button" data-qv-step="1" aria-label="Zwiększ ilość">' + I.plus + '</button></div>' +
        '<button type="button" class="vz-btn" data-qv-add><span class="vz-spin" aria-hidden="true"></span><span class="vz-btn__lbl">Dodaj do koszyka</span></button></div>' +
        '<a class="vz-more" href="' + esc(p.url) + '">Zobacz pełny opis <svg class="vz-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></div></div>';
      var cur = v0;
      function paint() {
        var s = cur.compare_at_price > cur.price;
        var pb = $('[data-qv-price]', box); pb.classList.toggle('is-sale', s);
        pb.innerHTML = '<span class="vz-now">' + VZ.money(cur.price) + '</span>' + (s ? '<s>' + VZ.money(cur.compare_at_price) + '</s><span class="vz-price__off">−' + Math.round((1 - cur.price / cur.compare_at_price) * 100) + '%</span>' : '');
        var ab = $('[data-qv-add]', box); ab.disabled = !cur.available; $('.vz-btn__lbl', ab).textContent = cur.available ? 'Dodaj do koszyka' : 'Wyprzedane';
      }
      paint();
      box.onchange = function (e) { if (e.target.name === 'qv-v') { cur = p.variants.find(function (v) { return String(v.id) === e.target.value; }); paint(); } };
      box.onclick = function (e) {
        var t = e.target.closest('[data-qv-thumb]');
        if (t) { $('[data-qv-img]', box).src = VZ.img(t.getAttribute('data-qv-thumb'), 900); $$('[data-qv-thumb]', box).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); }); }
        var st = e.target.closest('[data-qv-step]'), q = $('[data-qv-qty]', box);
        if (st) q.value = Math.max(1, (+q.value || 1) + +st.getAttribute('data-qv-step'));
        var a = e.target.closest('[data-qv-add]');
        if (a) VZ.addToCart([{ id: cur.id, quantity: +q.value || 1 }], a);
      };
    }).catch(function () { box.innerHTML = '<div style="padding:40px" class="vz-alert vz-alert--err">Nie udało się wczytać produktu.</div>'; });
  };
  doc.addEventListener('click', function (e) { var b = e.target.closest('[data-vz-qv]'); if (b) { e.preventDefault(); e.stopPropagation(); VZ.quickView(b.getAttribute('data-vz-qv')); } });

  /* ---------- Odliczanie ---------- */
  function initCountdown(scope) {
    $$('[data-vz-countdown]', scope).forEach(function (el) {
      if (el._vz) return; el._vz = true;
      var end = Date.parse(el.getAttribute('data-vz-countdown'));
      if (isNaN(end)) { el.hidden = true; return; }
      var parts = $$('b', el);
      function tick() {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        var v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
        parts.forEach(function (b, i) { b.textContent = String(v[i]).padStart(2, '0'); });
        if (!s) { el.classList.add('is-over'); var lbl = el.getAttribute('data-over'); if (lbl && el.nextElementSibling && el.nextElementSibling.hasAttribute('data-vz-cd-note')) el.nextElementSibling.textContent = lbl; return; }
        setTimeout(tick, 1000 - (Date.now() % 1000));
      }
      tick();
    });
  }

  /* ---------- Slider ---------- */
  function initSliders(scope) {
    $$('[data-vz-slider]', scope).forEach(function (s) {
      if (s._vz) return; s._vz = true;
      var t = $('.vz-slider__track', s), prev = $('[data-prev]', s), next = $('[data-next]', s), bar = $('.vz-progress i', s);
      if (!t) return;
      function step() { var c = t.children[0]; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(t).columnGap) || 16) : 300; }
      function upd() {
        var max = t.scrollWidth - t.clientWidth;
        if (prev) prev.disabled = t.scrollLeft <= 4;
        if (next) next.disabled = t.scrollLeft >= max - 4;
        if (bar) bar.style.setProperty('--p', max > 0 ? Math.max(.1, (t.scrollLeft + t.clientWidth) / t.scrollWidth) : 1);
      }
      if (prev) prev.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: RM.matches ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: RM.matches ? 'auto' : 'smooth' }); });
      t.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd, { passive: true }); upd();
    });
  }

  /* ---------- Akordeony ---------- */
  doc.addEventListener('click', function (e) {
    var sum = e.target.closest('details.vz-acc > summary, details.vz-filter > summary'); if (!sum || RM.matches) return;
    var d = sum.parentElement, body = sum.nextElementSibling; if (!body || !body.animate) return;
    e.preventDefault();
    if (d._a) d._a.cancel();
    if (d.open) {
      d._a = body.animate([{ height: body.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' });
      d._a.onfinish = function () { d.open = false; d._a = null; };
    } else {
      d.open = true;
      d._a = body.animate([{ height: '0px', opacity: 0 }, { height: body.offsetHeight + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.16,1,.3,1)' });
      d._a.onfinish = function () { d._a = null; };
    }
  });

  /* ---------- Strona produktu ---------- */
  function initProduct(scope) {
    $$('[data-vz-product]', scope).forEach(function (P) {
      if (P._vz) return; P._vz = true;
      var de = $('script[data-vz-variants]', P), variants = de ? JSON.parse(de.textContent) : [];
      var form = $('form[data-vz-form]', P), idIn = form && $('input[name="id"]', form);
      var add = $('[data-vz-add]', P), priceBox = $('[data-vz-price]', P), stock = $('[data-vz-stock]', P);
      var low = parseInt(P.getAttribute('data-low') || '10', 10);
      var sticky = $('.vz-sticky', P), sAdd = sticky && $('[data-vz-sticky-add]', sticky), sPrice = sticky && $('[data-vz-sticky-price]', sticky);
      var track = $('.vz-gallery__track', P), thumbs = $$('.vz-thumbs button', P), dots = $$('.vz-dots i', P), qty = $('[data-vz-qty]', P);
      function sel() { return $$('.vz-opt', P).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; }); }
      function current() { if (!$$('.vz-opt', P).length) { return variants.find(function (v) { return idIn && String(v.id) === String(idIn.value); }) || variants[0]; } var s = sel(); return variants.find(function (v) { return v.options.every(function (o, i) { return o === s[i]; }); }); }
      function avail() {
        var fs = $$('.vz-opt', P), s = sel();
        fs.forEach(function (f, idx) { $$('input', f).forEach(function (inp) { var t = s.slice(); t[idx] = inp.value; inp.classList.toggle('is-na', !variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === t[i]; }); })); }); });
      }
      function goTo(i, sm) { if (!track || !track.children[i]) return; track.scrollTo({ left: track.children[i].offsetLeft, behavior: sm && !RM.matches ? 'smooth' : 'auto' }); }
      function active(i) { thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); }); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
      function update() {
        var v = current();
        if (!v) { if (add) { add.disabled = true; $('.vz-btn__lbl', add).textContent = 'Niedostępne'; } return; }
        if (idIn) idIn.value = v.id;
        var s = v.compare_at_price > v.price;
        if (priceBox) { priceBox.classList.toggle('is-sale', s); priceBox.innerHTML = '<span class="vz-now">' + VZ.money(v.price) + '</span>' + (s ? '<s>' + VZ.money(v.compare_at_price) + '</s><span class="vz-badge vz-badge--sale">−' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>' : ''); }
        if (sPrice) sPrice.textContent = VZ.money(v.price);
        if (add) { add.disabled = !v.available; $('.vz-btn__lbl', add).textContent = v.available ? 'Dodaj do koszyka' : 'Wyprzedane'; }
        if (sAdd) sAdd.disabled = !v.available;
        if (stock) {
          var q = v.inventory, isLow = v.available && q != null && q > 0 && q <= low;
          stock.classList.toggle('is-out', !v.available); stock.classList.toggle('is-low', isLow);
          $('span', stock).textContent = !v.available ? 'Chwilowo niedostępny' : (isLow ? 'Ostatnie sztuki — zostało tylko ' + q + ' szt.' : 'Dostępny — wysyłka po zaksięgowaniu płatności');
        }
        $$('[data-vz-opt-val]', P).forEach(function (el, i) { el.textContent = v.options[i] || ''; });
        if (v.media_index > -1) goTo(v.media_index, true);
        if (P.hasAttribute('data-update-url') && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
        avail();
      }
      P.addEventListener('change', function (e) { if (e.target.closest('.vz-opt')) update(); });
      P.addEventListener('click', function (e) { var b = e.target.closest('[data-vz-step]'); if (b && qty) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-vz-step'), 10)); });
      function go(btn) { VZ.addToCart([{ id: +idIn.value, quantity: parseInt(qty && qty.value, 10) || 1 }], btn); }
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); go(add); });
      if (sAdd) sAdd.addEventListener('click', function () { go(sAdd); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i, true); active(i); }); });
      if (track) {
        track.addEventListener('scroll', function () { requestAnimationFrame(function () { active(Math.round(track.scrollLeft / track.clientWidth)); }); }, { passive: true });
        if (window.matchMedia('(hover:hover) and (min-width:1000px)').matches) $$('.vz-gallery__slide', track).forEach(function (s) {
          s.addEventListener('mousemove', function (e) { var r = s.getBoundingClientRect(), im = $('img', s); im.style.setProperty('--zx', (e.clientX - r.left) / r.width * 100 + '%'); im.style.setProperty('--zy', (e.clientY - r.top) / r.height * 100 + '%'); });
          s.addEventListener('click', function () { s.classList.toggle('is-zoom'); });
          s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
        });
      }
      if (sticky && add && 'IntersectionObserver' in window) new IntersectionObserver(function (en) {
        var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on); root.classList.toggle('vz-sticky-on', on);
      }).observe(add);
      update();
    });
  }

  /* ---------- Polecane ---------- */
  function initReco(scope) {
    $$('[data-vz-reco]', scope).forEach(function (el) {
      if (el._vz) return; el._vz = true;
      var url = el.getAttribute('data-vz-reco'); if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var t = doc.createElement('div'); t.innerHTML = html; var n = $('[data-vz-reco]', t);
        if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; initAll(el); } else { var s = el.closest('.vz-sec'); if (s) s.hidden = true; }
      }).catch(function () {});
    });
  }

  /* ---------- Katalog ---------- */
  function initCatalog(scope) {
    $$('[data-vz-sort]', scope).forEach(function (s) { s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); }); });
    $$('form[data-vz-filters]', scope).forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(f), u = new URL(location.href), keep = u.searchParams.get('sort_by'), q = new URLSearchParams();
        fd.forEach(function (v, k) { if (v !== '') q.append(k, v); }); if (keep) q.set('sort_by', keep);
        location.href = u.pathname + (q.toString() ? '?' + q : '');
      });
    });
  }

  /* ---------- Formularze ---------- */
  function initForms(scope) {
    $$('form[data-vz-validate]', scope).forEach(function (f) {
      if (f._vz) return; f._vz = true; f.setAttribute('novalidate', '');
      f.addEventListener('submit', function (e) {
        var bad = null;
        $$('.vz-field', f).forEach(function (fl) { var i = $('input,textarea', fl); if (!i) return; var ok = i.checkValidity(); fl.classList.toggle('is-invalid', !ok); i.setAttribute('aria-invalid', ok ? 'false' : 'true'); if (!ok && !bad) bad = i; });
        if (bad) { e.preventDefault(); e.stopImmediatePropagation(); bad.focus(); }
      });
      f.addEventListener('input', function (e) { var fl = e.target.closest('.vz-field'); if (fl && e.target.checkValidity()) { fl.classList.remove('is-invalid'); e.target.setAttribute('aria-invalid', 'false'); } });
    });
  }

  function initAll(scope) { initReveal(scope); initSliders(scope); initProduct(scope); initReco(scope); initCatalog(scope); initForms(scope); initCountdown(scope); wishSync(); }
  VZ.init = initAll;
  function boot() {
    initHeader(); initAll(doc);
    VZ.api.get().then(function (c) { VZ.setCount(c.item_count); }).catch(function () {});
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  doc.addEventListener('shopify:section:load', function (e) { initAll(e.target); $$('[data-vz-reveal],.vz-stage,.vz-bar', e.target).forEach(function (x) { x.classList.add('is-in'); }); });
  doc.addEventListener('shopify:section:select', function (e) { $$('[data-vz-reveal],.vz-stage,.vz-bar', e.target).forEach(function (x) { x.classList.add('is-in'); }); });
})();


  } catch(e) { console.error(e); }
})();
})();
